import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Фирменные шрифты по брендбуку (стр. 35):
// Unbounded-Semibold — заголовки (санкционированная замена Benzin-Semibold),
// Montserrat Medium/Bold — наборный текст и выделение.
import '@fontsource/unbounded/600.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';

import './styles/tokens.css';
import './styles/base.css';
import './styles/ui.css';

import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
